import { render } from "./DuplicationStep.vue?vue&type=template&id=2f20200f"
import script from "./DuplicationStep.vue?vue&type=script&lang=js"
export * from "./DuplicationStep.vue?vue&type=script&lang=js"

import "./DuplicationStep.vue?vue&type=style&index=0&id=2f20200f&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__